import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function MultiRadialBar() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [
          colors.ReactifyChartColor1,
          colors.ReactifyChartColor2,
          colors.ReactifyChartColor3,
          colors.ReactifyChartColor4
        ],
        labels: ["Bootstrap", "ReactJS", "CSS3", "MYSQL"],
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px"
            },
            value: {
              fontSize: "16px"
            },
            total: {
              show: true,
              label: "Total",
              formatter: function() {
                return 249;
              }
            }
          }
        }
      },
      series: [44, 55, 67, 83]
    }),
    []
  );

  return (
    <Chart
      options={options}
      series={series}
      type="radialBar"
      width="100%"
      height="280px"
    />
  );
}

export default MultiRadialBar;
